import { render, staticRenderFns } from "./groupingActivity.vue?vue&type=template&id=2adc5fb0&scoped=true&"
import script from "./groupingActivity.vue?vue&type=script&lang=js&"
export * from "./groupingActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc5fb0",
  null
  
)

export default component.exports